export const HtmlEditorMessages = {
  buttons: {
    html: {
      id: 'htmlEditor.Buttons.Html',
      defaultMessage: 'HTML',
    },
    text: {
      id: 'htmlEditor.Buttons.Text',
      defaultMessage: 'Text',
    },
  },
};